<template>
  <main class="symbolsListWrapper" :class="{isFloating}" :style="setZindex()">
    <!--    <h3 id="title" :class="{feedTitle: isMini}">{{ dictionary.topTen.proTitle }}</h3>-->
    <!--    <tabs id="categoryTabs" :tabs="tabs" :active-tab="tab"/>-->

    <TableToolbar :buttons="[(isFloating ? 'close' : '')]"
                  :id="'symbolsList'"
                  :isFilterShown="showFilter"
                  :title="listTitle"
                  @cancelFilter="showFilter = false;"
                  @close="$emit('close')"
                  @toggleFilter="showFilter = !showFilter">
      <template #toolbarFilter="{filterButtonRef}">
        <ListFilter v-if="showFilter" @cancel="showFilter = false" @applyFilter="applyFilter"
                    :filterButtonRef="filterButtonRef" :defaultSelect="filters"/>
      </template>


      <template #main>

      </template>
    </TableToolbar>

    <big-loader v-if="isLoading"></big-loader>
    <section v-else ref="gainers">

      <DataGridTable :is-compact="true"
                     :key="tableKey"
                     :data="list"
                     :hovered-columns="true"
                     :loaded="isLoading"
                     :pagination="true"
                     :currentPage="visiblePage"
                     :numOfPages="10"
                     :height-decrease="isFloating ? -20 : 17"
                     :default-sort="defaultSort"
                     :heightElements="['signalsTabs']"
                     :default-sort-direction="defaultSortDirection"
                     :extra-headers="[ {
          position: 2,
          label: this.dictionary.signals.high52,
          sortValue: 'signals.high52Delta'
        }]"
                     :fixed-col="0">
        <template
            #thead="{thClick, sortKey, sortDirection, xAxisScrolled, toggleSymbolActions, showSymbolActions, headers}">
          <HeadCell v-for="(th, thIndex) in headers"
                    :sortKey="sortKey"
                    :header="th"
                    :sortDirection="sortDirection"
                    :sortValue="th.sortValue"
                    :showSymbolActions="showSymbolActions"
                    @toggleSymbolActions="toggleSymbolActions()"
                    @sort="thClick(th.sortValue, thIndex)">
            {{ th.label }}
          </HeadCell>
        </template>

        <template #tbody="{rows, showSymbolActions}">
          <tr v-for="(row, rowIndex) in rows" :key="`r-${rowIndex}`">
            <td>
              <symbol-tag :tags="row.tags" :options="{link: true, chart: true, logo: 'small'}"
                          :showSymbolActions="showSymbolActions" :symbol="row.symbol"/>
            </td>
           
            <td>
              <symbol-label :key="`s-${row.symbol}`"
                            :pre-market-quote="row.tradingData?.preMarket"
                            :post-market-quote="row.tradingData?.postMarket"
                            :onlyPostMarket="activeButton === 'postMarket'"
                            :onlyPreMarket="activeButton === 'preMarket'"
                            :symbol="row?.tradingData" :price-only="true"
                            :force-pre-post="activeButton !== 'tradingHours'"
                            :hide-pre-post="activeButton === 'tradingHours'"
                            :show-prePost="activeButton !== 'tradingHours'" :always-on="true"/>
            </td>
  
            
            <PriceDistance :tag="'td'" :symbol="row.symbol" :threshold="3"
              :previousClose="row.tradingData?.price" :direction="'top'" :defaultPrice="row.tradingData?.price"
              :value="row.tradingData?.fiftyTwoWeeksHigh" @deltaChange="deltaChange(row.symbol, $event, 'high52D')" />
          <VolumeCell :volume="row.tradingData?.formattedVolume" :trend="row.tradingData?.volumeTrend" />
            <td>
              {{ row.tradingData?.formattedMarketCap }}
            </td>
                <NumericCell
                :value="row.tradingData?.atr?.atrPercent"
                :ranges="[0, 1, 3, 5, 7]"
                :classes="['low','moderate','medium','high','extreme']"
            />
            <TrendIconCell :trend="row.tradingData?.atr?.atrTrend"/>
            <TrendIconCell :trend="row.tradingData?.obvTrend"/>
            <NumericCell v-for="period in ['5D','10D','1M']" :value="row.eods?.[period]"/>


            <PriceDistance :tag="'td'" :symbol="row.symbol" :threshold="3"
                           :previousClose="row.tradingData?.price" :direction="'top'"
                           :defaultPrice="row.tradingData?.price" :value="row.tradingData?.ma50"
                           @deltaChange="deltaChange(row.symbol, $event, 'ma50D')"/>
            <PriceDistance :tag="'td'" :symbol="row.symbol" :threshold="3"
                           :previousClose="row.tradingData?.price" :direction="'bottom'"
                           :defaultPrice="row.tradingData?.price" :value="row.tradingData?.ma200"
                           @deltaChange="deltaChange(row.symbol, $event, 'ma200D')"/>

            <YearlyRangeCell :delta-change="this.deltaChange" :row="row"/>

            <RSICell :rsi="row.tradingData?.rsi"/>
            <MACDCell :macd="row.tradingData?.macd"/>
        
            <NumericCell :noColor="true" :value="row.tradingData?.eps"/>
            <NumericCell :noColor="true" :value="row.tradingData?.pe"/>
            <IndustrySectorCell :symbol="row"/>
          </tr>
        </template>
      </DataGridTable>
    </section>

  </main>
</template>

<script>

import Endpoint from '../../services/endpoint';
import SymbolLabel from "../../components/symbols/symbol";
import BigLoader from "../../components/ui/BigLoader";
import DataGridTable from "../../components/dataGrid/DataGridTable";
import Tabs from "../../components/ui/Tabs";
import HeadCell from "../../components/dataGrid/HeadCell";
import SymbolLogo from "../../components/symbols/symbolLogo";
import UserService from "../../services/user";
import SignalsService from "../../services/signals";
import {useWatchlist} from "../../stores/watchlist";
import DropDown from "../../components/ui/DropDown";
import SymbolLink from "../../components/symbols/symbolLink";

import quoteStreaming from "../../composables/quoteStreaming";
import {useNewYorkTime} from "../../stores/newYorkTime";
import ListFilter from "../../components/filter/ListFilter";
import TableToolbar from "../../components/ui/TableToolbar";
import PriceDistance from "../../components/priceTags/priceDistance";
import SymbolChart from "../../components/symbols/symbolChart";
import SymbolTag from "../../components/symbols/symbolTag";
import PriceRange from "../../components/priceTags/priceRange";
import NumericCell from "../../components/dataGrid/NumericCell";
import YearlyRangeCell from "../../components/dataGrid/YearlyRangeCell";
import RSICell from "../../components/dataGrid/RSICell";
import MACDCell from "../../components/dataGrid/MACDCell";
import TrendIconCell from "../../components/dataGrid/TrendIconCell";
import IndustrySectorCell from "../../components/dataGrid/IndustrySectorCell";
import VolumeCell from "../../components/dataGrid/VolumeCell";

export default {
  name: "High52Signal",
  components: {
    IndustrySectorCell,
    TrendIconCell,
    MACDCell,
    RSICell,
    YearlyRangeCell,
    NumericCell,
    PriceRange,
    SymbolTag,
    SymbolChart,
    PriceDistance,
    TableToolbar,
    ListFilter,
    SymbolLink, DropDown, SymbolLogo, HeadCell, Tabs, DataGridTable, BigLoader, SymbolLabel,
    VolumeCell
  },
  props: ['prices', 'isMini', 'endpoint', 'listTitle', 'isFloating', 'signals', 'filters'],
  setup() {

    const marketStatus = useNewYorkTime();
    const {updateStream, leaveStream} = quoteStreaming();
    return {updateStream, leaveStream, marketStatus};
  },
  data() {
    return {
      list: [],
      showFilter: false,
      watchlist: useWatchlist(),
      visiblePage: 1,
      page: 0,
      limit: 50,
      defaultSort: 'tradingData.marketCap',
      defaultSortDirection: -1,
      tableKey: 0,
      isLoading: true,
      loadingInterval: null
    }
  },
  methods: {
    setZindex() {
      if (this.isFloating) {
        return {zIndex: new Date().getTime()}
      }
    },
    deltaChange(symbol, value, key) {


    },
    async applyFilter() {

      await this.loadList(true)
    },
    async addRemoveWatchlistSymbol(symbol) {

      if (this.watchlist.watchlist.includes(symbol)) {

        try {
          mixpanel.track('symbol:remove', {client: window.location.host, symbol: symbol});
        } catch (e) {
        }

        const watchlist = await UserService.removeSymbolFromWatchlist(symbol)
        this.watchlist.updateWatchlist(watchlist);
      } else {

        try {
          mixpanel.track('symbol:add', {client: window.location.host, symbol: symbol});
        } catch (e) {
        }
        const watchlist = await UserService.addSymbolToWatchlist(symbol)
        this.watchlist.updateWatchlist(watchlist);
      }
    },
    async loadList(showLoading = true, shouldLeave = true) {

      if (showLoading) this.isLoading = true;

      let request = {signals: this.signals, filters: this.filters}
      this.list = await SignalsService.getSignals(request)
      this.isLoading = false;
    }
  },
  beforeUnmount() {
    clearInterval(this.loadingInterval);
  },
  beforeMount() {
    this.loadList().then().catch();
    this.loadingInterval = setInterval(() => {

      this.loadList(false).then().catch()
    }, 2000 * 60);
  }
}
</script>

<style scoped lang="scss">

@import "../../assets/style/vars";
@import "../../assets/style/calendar";
@import "../../assets/style/general";

.tab {
  width: 33%;

}

.symbolRow {
  border-bottom: 1px solid var(--notficationBorderColor);
  padding: $smallGap;

  &:last-of-type {
    border-bottom: none;
  }
}

h2 {
  margin: 0 $smallGap $smallGap;
  padding: 0;
}

h3 {
  color: var(--textColor);
  margin: 0;
  padding: 5px 10px;

}

#topTable {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  section {
    width: 100%;
  }
}

.symbolTd {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}

.addRemoveSymbol {
  flex: 0 0 55px !important;
  width: 45px;
  margin-left: auto;

  &[dir="rtl"] {
    margin-left: unset;
    margin-right: auto;
  }

  i {
    display: none;
  }

  @media(max-width: 660px) {

    flex: 0 0 30px !important;
    width: 30px;
    height: 20px;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    i {
      display: block;
    }

    span {
      //display: none;
    }
  }
}

.tabs.round {
  z-index: 2;
  padding: 3px 5px !important;
  margin: 0 !important;
}

#filterPanel {
  padding: 0;
  display: flex;
  align-items: center;
  gap: 1rem;

  #flexBlock {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  @media(max-width: 660px) {
  }

}

#topBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--notficationBorderColor) !important;

  @media(max-width: 660px) {
    display: block;
  }
}

.tabs:not(.round) {
  position: unset;
}

.isFloating {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--bgColor);
  z-index: 9999999;
}

.signal {
  text-align: center;
  padding: 7px 10px !important;
  height: 21px !important;
}

.low {
  background: var(--opacityRed);
}

.high {
  background: var(--opacityGreen);
}

</style>

